import { HttpParams } from '@angular/common/http';
import { QUERY_PARAM_ARRAY_DELIMITER } from '../constants';

export function toHttpParams(obj: { [key: string]: any }): HttpParams {
  let params = new HttpParams();

  Object.keys(obj).forEach(key => {
    let value = obj[key];
    if (value === undefined) { return; }

    if (Array.isArray(value)) {
      value = value.join(QUERY_PARAM_ARRAY_DELIMITER);
    }

    params = params.set(key, encodeURIComponent(value.toString()));
  });

  return params;
}
